<template>
  <div>
    <section class="">
      <div class="" v-if="this.permission_add >= 1">
        <div class="form-group">
          <label>{{ __("forms.KPIPeople.kpiName") }}</label>
          <select

            class="form-control"
            v-model="newKpiSelected"
            @change="getKpiAttributes()"
          >
            <option v-for="opt in kpi_list" :value="opt.id" v-bind:key="opt.id">
              {{ opt.name }}
            </option>
          </select>
        </div>

        <div class="form-group" v-if="indicators_preset.length > 0">
          <label>{{ __("forms.KPIPeople.indicator") }}</label>
          <select required class="form-control" v-model="newIndicatorKpiPerson" @change="resetError()">
            <option v-if="!limit_indicators">---</option>
            <option
              v-for="indicator in indicators_available"
              v-if="indicators_preset.includes(indicator['slug_name'])"
              :value="indicator['slug_name']"

              v-bind:key="indicator['slug_name']"
            >
              {{ indicator.name }}
            </option>
          </select>
        </div>

        <div class="form-group" v-if="show_unit_measure">
          <label>{{ __("forms.KPIS.unit_measure") }}</label
          >:
          <label>{{ unit_measure }}</label>
        </div>

        <div class="form-group" v-if="show_prize_value">
          <label>{{ prize_name }}</label>
          <input class="form-control" v-model="newPrize" type="number" />
        </div>
        <div v-if="show_target_100">
          <div class="form-group" v-if="enable_change_target">
            <label>{{ __("forms.KPIPeople.target") }}</label>
            <input
              class="form-control"
              type="number"
              step="0.01"
              v-model="targetUpdated"
            />
          </div>
          <div class="form-group" v-else>
            <label
              >{{ __("forms.KPIPeople.target") }}: {{ targetEnchanted }}</label
            >
          </div>
          <p v-if="errorMessageId != 0 ">
            <i class="fas fa-triangle-exclamation" style="color: red"></i>
            <label v-if="errorMessageId == 1">{{ __("forms.EvaluationChart.questions.questions_setting.question12.addExsistingKpi.noKpiSelected") }}</label>
            <label v-if="errorMessageId == 2">{{ __("forms.EvaluationChart.questions.questions_setting.question12.addExsistingKpi.noTypologySelected") }}</label>
          </p>
        </div>
        <div class="form-buttons clear">
          <button
            style="margin-top: 33px"
            type="button"
            class="btn btn--green"
            @click="addKpiPerson()"
          >
            <i class="fa fa-plus-circle"></i>
            {{ __("forms.KPIS.add_kpi") }}
 
          </button>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  mounted() {
    //
    this.getKpis();
  },
  props: {
    limit_indicators: {
      type: Boolean,
      required: true,
    },
    kpi_group_id: {
      type: Number,
      required: true,
    },
    kpi_incentive_plan_id: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    permission_add: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    prize_mode: {
      type: String,
      required: true,
    },
    prize_name: {
      type: String,
      required: true,
    },
      lang: {
      type: String,
      required: true,
    },
    indicators_available: {
      type: Array,
      required: false,
      default: [],
    },
    indicators_preset: {
      type: Array,
      required: false,
      default: [],
    },
    approve_kpi: {
      type: Boolean,
      required: true,
    },
    show_prize_value: {
      type: Boolean,
      required: true,
    },
    show_unit_measure: {
      type: Boolean,
      required: true,
    },
     show_target_100: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      newKpiSelected: null,
      kpi_list: [],
      newIndicatorKpiPerson: null,
      newPrize: null,
      targetUpdated: 0,
      enable_change_target: false,
      threshold: null,
      targetEnchanted: null,
      unit_measure: null,
      errorMessageId : 0,
    };
  },
  methods: {
    getKpis() {
      axios
        .get("/get-kpi-for-existing-add", {
          params: {
            kpi_incentive_plan_id: this.kpi_incentive_plan_id,
            owner_person_id: this.owner_person_id,
            question_survey_id: this.question_survey_id,
          },
        })
        .then((response) => {          
          this.kpi_list = response.data.kpiList;
        });
    },
 
    resetError(){
        this.errorMessageId = 0;
    },
    getKpiAttributes() {
      axios
        .get("/get-kpi-for-attributes/" + this.newKpiSelected + "/kpi")
        .then((response) => {
          let kpi = response.data.kpi;
          let segmentation = response.data.segmentation;
          this.unit_measure = kpi.unit_measure.lang;
          if (segmentation.automatic_percentage_calculation == 1) {
            this.enable_change_target = true;
            this.targetUpdated = response.data.target;
          } else {
            this.enable_change_target = false;
            this.targetUpdated = 0;
            this.targetEnchanted = response.data.targetEnchanted;
          }

          this.newPrize = 0;
        });
        this.resetError();
    },
    addKpiPerson() {
      if (this.newKpiSelected === null) {
        this.errorMessageId = 1;
        return;
      }
      if (this.newIndicatorKpiPerson === null) {
        this.errorMessageId = 2; '{{__("EvaluationChart.questions.questions_setting.question12.addExsistingKpi.noTypologySelected")}}';
        return;
      }

      if (this.newPrize === null) {
        this.newPrize = 0;
      }

      let params = {
        kpi_id: this.newKpiSelected,
        target_bonus: this.targetBonus,
        owner_person_id: this.owner_person_id,
        kpis_incentive_plan_id: this.kpi_incentive_plan_id,
        kpi_key_prize: this.newPrize,
        prize_mode: this.prize_mode,
        indicator: this.newIndicatorKpiPerson,
        question_survey_id: this.question_survey_id,
        approve_kpi: this.approve_kpi,
        target_updated: this.targetUpdated,
        enable_change_target: this.enable_change_target,
      };

      axios.post("/add-people-kpi-target-chart", params).then((response) => {
        if (response.data == -10) {
          Vue.swal.fire({
            title:
              "Hai raggiunto il limite massimo di Kpi per quella tipologia",
          });
        }
        app.__vue__.$refs.vue_popup.active = false;
 
        if( app.__vue__.$refs["question_target_kpi_chart_" + this.question_survey_id] != null){
          app.__vue__.$refs["question_target_kpi_chart_" + this.question_survey_id].populateKpiTable();
        }
        else {
          //the targetQuestion maybe is nested in can_enable_question_target_kpi_chart_# ??
          app.__vue__.$refs["can_enable_question_target_kpi_chart_" + this.question_survey_id].
            $refs["question_target_kpi_chart_" + this.question_survey_id].populateKpiTable();
        }
      });
    },
  },
};
</script>

<style>
</style>
